export default {
    PREFERENCIAS:{
        IPM_VIEW_MODE: 'pref_ipm_view_mode'
    }
}